import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '~/redux/configureStore';
import GlobalHeader from '~/components/header/global-header';
import ErrorBoundary from '~/components/common/error-boundary';
import '~/sass/header.scss';

const errorMessage =
	'undefined' !== typeof LearnDashData
		? LearnDashData.error_messages &&
		  LearnDashData.error_messages.header &&
		  LearnDashData.error_messages.header
		: 'Sorry, something went wrong with LearnDash header.';

ReactDOM.render(
	<Provider store={ store }>
		<ErrorBoundary message={ errorMessage } className="header-boundary">
			<GlobalHeader el="sfwd-header" />
		</ErrorBoundary>
	</Provider>,
	document.getElementById( 'sfwd-header' )
);
